import {
  type PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useMemo,
  type FC,
} from 'react'
import { useParams } from 'react-router'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { InboxLayerStore } from 'pages/settings/pages/inboxes/pages/id/store/inboxLayerStore'
import { useInboxesViewContext } from './inboxesViewContext'

const InboxLayerContext = createContext<InboxLayerStore | null>(null)

export const useInboxLayerContext = () => {
  const context = useContext(InboxLayerContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with InboxLayerProvider')

  return context
}

export const InboxLayerProvider: FC<PropsWithChildren> = ({ children }) => {
  const { id } = useParams()
  const { inboxesViewStore } = useInboxesViewContext()
  const entities = useEntitiesContext()
  const store = useMemo(
    () => new InboxLayerStore(inboxesViewStore, entities, Number(id)),
    [inboxesViewStore, entities, id]
  )

  useEffect(() => {
    store.initOnMount()
    return () => store.dispose()
  }, [store])
  return <InboxLayerContext.Provider value={store}>{children}</InboxLayerContext.Provider>
}
